import { useState } from 'react';
import { roleValidationService } from '../../services';

export const useRoleForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateField = (field: 'name' | 'description', value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    
    // Limpiar error del campo cuando el usuario empiece a escribir
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const validateForm = (): boolean => {
    const newErrors: { [key: string]: string } = {};

    // Validar nombre
    const nameValidation = roleValidationService.validateRoleName(formData.name);
    if (!nameValidation.isValid) {
      newErrors.name = nameValidation.message || '';
    }

    // Validar descripción
    const descValidation = roleValidationService.validateRoleDescription(formData.description);
    if (!descValidation.isValid) {
      newErrors.description = descValidation.message || '';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetForm = () => {
    setFormData({ name: '', description: '' });
    setErrors({});
    setIsSubmitting(false);
  };

  const setSubmitting = (submitting: boolean) => {
    setIsSubmitting(submitting);
  };

  return {
    formData,
    errors,
    isSubmitting,
    updateField,
    validateForm,
    resetForm,
    setSubmitting
  };
};
